import { Injectable } from '@angular/core';
import { HttpMethodsService } from './http-methods.services';
import { map } from 'rxjs';
import { BannerModel } from '../_models/banner.model';

@Injectable({ providedIn: 'root' })
export class BannersService {
  constructor(private _httpService: HttpMethodsService) {}

  /**
   * Obtiene todos los banners activos desde el backend cliente.
   * ESTÁNDAR APLICADO: Mapea TODAS las respuestas HTTP a modelos usando RxJS map()
   * para asegurar que el store NgRx contenga objetos correctamente instanciados.
   * @returns Observable con array de BannerModel y total
   */
  findAll() {
    return this._httpService.get('banners_active').pipe(
      map((res: any) => ({
        data: res?.data.map((r: any) => new BannerModel(r)),
        total: res?.data?.length || 0,
      }))
    );
  }
}
